/*
 * @LastEditTime: 2022-06-30 11:26:25
 */
import React, { Component } from 'react';
import './index.less';
import logo_icon from './img/logo.png';
import line_icon from './img/line.png';
import erCode_icon from './img/erCode.jpeg';
import arrow_icon from './img/arrow.png';
/**
 * 页脚
 */
class Footer extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            data: ['收集需求', '面谈沟通', '出具方案', '沟通完善方案', '签约实施', '交付'],
        }
    }
    render() {
        const { data } = this.state;
        return (
            <div className="footer">
                <div className="footer__wrapper">
                    <div className="footer__left">
                        <img className="footer__left-logo" src={logo_icon} />
                        <p>客服电话：400-050-8080转2号</p>
                        <p>京ICP备10012705号-12 京公网安备11010502027237号</p>
                    </div>
                    <img src={line_icon} className="footer__center" />
                    <div className="footer__right">
                        <div className="footer__right-erCode">
                            <img src={erCode_icon} />
                            <p>官方客服</p>
                        </div>
                        <div className="footer__right-des">
                            <p>为您提供专属人力资源数字化解决方案</p>
                            <p>超值优惠，超高性价比</p>
                            <ul className="footer__right-steps">
                                {
                                    data.map((item, index) => {
                                        return (
                                            <li key={index}>
                                                <span>{item}</span>
                                                {
                                                    index !== data.length - 1 &&
                                                    <img src={arrow_icon} />
                                                }
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Footer;